import { render, staticRenderFns } from "./FileCard.vue?vue&type=template&id=655a5a73"
import script from "./FileCard.vue?vue&type=script&lang=ts"
export * from "./FileCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports